var map = {
	"./template.bet777": 1687,
	"./template.bet777.tsx": 1687,
	"./template.default": 265,
	"./template.default.tsx": 265,
	"./template.puntcity": 1688,
	"./template.puntcity.tsx": 1688,
	"./template.sterlingparker": 1689,
	"./template.sterlingparker.tsx": 1689,
	"./template.templebet": 1690,
	"./template.templebet.tsx": 1690,
	"./template.ts": 988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2465;